module.exports = __webpack_public_path__ + "static/img/mapa_esp.fde716b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/mapa_esp.png
// module id = n4eH
// module chunks = 1